const adminReducer = function (state = { toolId: null, tableData: null, rules_basic: null, connection_type: null, requestId: [], requestState: {} }, action) {
    switch (action.type) {
        case "GET_TOOLID":
            return { ...state }
        case "SET_TOOLID":
            return { ...state, toolId: action.payload }
        case "SET_TABLEDATA":
            return { ...state, tableData: action.payload }
        case "SET_DATA_FILTER":
            return { ...state, rules_basic: action.payload }
        case "SET_CONNECTION_TYPE":
            return { ...state, connection_type: action.payload }
        case "SET_REQUEST_ID":
            return { ...state, requestId: state.requestId ? [...state.requestId, action.payload] : [action.payload] }
        case "SET_REQUEST_STATE":
            return { ...state, requestState: action.payload, requestId: Object.keys(action.payload) }
        default:
            return state;
    }
}
export default adminReducer;